import { render, staticRenderFns } from "./SliderDisplay.vue?vue&type=template&id=0e4860e2"
import script from "./SliderDisplay.vue?vue&type=script&lang=ts"
export * from "./SliderDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports